import ApiService from "@/common/api.service"
import {fetchFileDataUrl, normalizeObjectPath} from "@/utils/fileDownload";

const fetchImageViaDownload = async (path) => {
    const objectPath = normalizeObjectPath(path);
    if (!objectPath) return null;

    try {
        const file = await fetchFileDataUrl(objectPath);
        if (!file?.dataUrl) return null;
        const contentType = (file.contentType || "").toLowerCase();
        if (contentType.includes("application/json")) return null;
        return file.dataUrl;
    } catch (error) {
        console.error("Failed to fetch image via download", error);
        return null;
    }
};

export const TrainerService = {
    create(params) {
        return ApiService.post("Trainers/add", params);
    },
    update(slug, params) {
        return ApiService.update("/Trainers", slug, params);
    },
    delete(slug, params) {
        return ApiService.delete("/Trainers/delete", slug, params)
    },
    async getTrainers() {
        const resp = await ApiService.get("/Trainers");
        return resp.data.rows;
    },
    async getTrainersWP(page, itemsPerPage, name) {
        const resp = await ApiService.get(
            `/Trainers?page=${page}&pageSize=${itemsPerPage}&name=${name}`
        );
        return resp.data;
    },
    completeTrainerCourse(param) {
        return ApiService.put("/trainers/course/completeCourse", param);
    },
    generateQrCode(params) {
        return ApiService.post("/generateQrCode/scan", params);
    },
    async getImage(params) {
        const imageUrl = params?.url;

        try {
            const downloadedImage = await fetchImageViaDownload(imageUrl);
            if (downloadedImage) {
                return {data: {data: downloadedImage}};
            }
        } catch (error) {
            console.error("Download image fetch failed", error);
        }

        try {
            return await ApiService.post("/getImageRequest/logo", params);
        } catch (error) {
            console.error("Legacy image fetch failed", error);
            return {data: {data: ""}};
        }
    },
    async getTrainer(slug) {
        const resp = await ApiService.get("/Trainers/" + slug);
        return resp;
    },
    async getPublicTrainerInfo(slug1, slug2, slug3) {
        const resp = await ApiService.get("/Trainers/public/" + slug1 + "/" + slug2 + "/" + slug3);
        if (resp.data?.status !== 200) {
            throw new Error(resp.data?.message || "Unable to fetch trainer information");
        }
        return resp.data.data;
    },
    async sendEmail(params) {
        const resp = await ApiService.postFormData(`/trainers/send-email`, params);
        return resp.data;
    },
    async approveCertificates(slug, params) {
        return ApiService.update("/approve-certificates", slug, params);
    },
    async signCertificates(slug, params) {
        return ApiService.update("/approve-certificates/sign", slug, params);
    },
    async verifyTrainer(id, params) {
        return ApiService.update("/trainers", `${id}/verification`, params);
    },

}
